import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IEventTicketState }    from 'Redux/Slices/EventTicket/EventTicketSlice';
import { EventTicket }          from 'Domain/Models';
import { PayloadActionList }    from 'Utils';
import { removeActionTypes }    from 'Utils/ReducerUtility';


export const findEventTicketsRequest = (state: Draft<IEventTicketState>, { type }: PayloadActionList) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const findEventTicketsSuccess = (state: Draft<IEventTicketState>, { type, payload }: PayloadAction<{
  eventTickets: Record<string, EventTicket>,
  maxCount: number,
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.entries = payload.eventTickets;
  state.maxCount = payload.maxCount || state.maxCount;

};

export const findEventTicketsFailure = (state: Draft<IEventTicketState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
